import { BreadcrumbLevel } from '../DialogBreadcrumbs/DialogBreadcrumbs.types';
import {
  IDragData,
  Score,
  Scheme,
  GradeRules,
  Task,
  TaskGroup,
  ExamSheet,
  Exam,
  IExamSession,
  CriteriaSetup,
} from '../../models/session.types';
import { sessionTreeDragItemType } from './SessionTreeDragItemType';
import React from 'react';

//TODO: define type for session tree item data
export type TreeItemData =
  | Score
  | Scheme
  | GradeRules
  | CriteriaSetup
  | Task
  | TaskGroup
  | ExamSheet
  | Exam
  | IExamSession;

export enum WorkMode {
  ADD,
  EDIT,
  VIEW,
}

export interface ICommonSessionTreeItemProps {
  activeTreeId: string;
  activeTreeLevel: BreadcrumbLevel;
  setActiveTreeId: (id: string) => void;
  setActiveTreeLevel: (level: BreadcrumbLevel) => void;
  editedItemId: string | null;
  setEditedItemId: (id: string) => void;
  isSessionImported: boolean;
  workMode: WorkMode;
  setWorkMode: (mode: WorkMode) => void;
  expandedItems: string[];
  setExpandedItems: (items: any[]) => void;
}

export interface SessionTreeProps extends ICommonSessionTreeItemProps {
  data: IExamSession;
  isSessionNameExpanded: boolean;
  level: BreadcrumbLevel;
  setIsSessionNameExpanded: (expanded: boolean) => void;
  translateName: string;
  translateIcon: string;
  removeTreeItem: () => void;
  isReadOnly: () => boolean;
  isTrainingSession?: boolean;
}

export interface SessionTreeItemProps extends ICommonSessionTreeItemProps {
  data: TreeItemData;
  level: BreadcrumbLevel;
  indent: string;
  dragType?: sessionTreeDragItemType;
  dropType?: sessionTreeDragItemType;
  dragDisabled?: boolean;
  dropDisabled?: boolean;
  dragData?: IDragData;
  onDropTreeItem?: (targetId: string, draggedItemId: string) => void;
  canDropTreeItem?: (target: TreeItemData, draggedItem?: TreeItemData) => boolean;
  onActivate: () => void;
  isReadOnly: () => boolean;
  isExamCodeReadOnly?: () => boolean;
  itemTitleIcon?: React.ReactNode;
  removeTreeItem?: () => void;
  isSheetConfigured?: boolean;
  taskGradeRulesId?: string;
  hideDeleteIcon?: boolean;
}

export enum NewTreeItemId {
  Exam = 'newExam',
  ExamSheet = 'newExamSheet',
  TaskGroup = 'newTaskGroup',
  Task = 'newTask',
  GradeRules = 'newGradeRules',
  CriteriaSetup = 'newCriteriaSetup',
  SchemeScores = 'newSchemeScores',
}

export const NewTreeItemsIds = [
  NewTreeItemId.Exam,
  NewTreeItemId.ExamSheet,
  NewTreeItemId.TaskGroup,
  NewTreeItemId.Task,
  NewTreeItemId.GradeRules,
  NewTreeItemId.CriteriaSetup,
  NewTreeItemId.SchemeScores,
];
